import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const FilterGlyph = /*#__PURE__*/createElement("g", {
  id: "filter"
}, /*#__PURE__*/createElement("path", {
  d: "M47.39,69.5A1.47,1.47,0,0,1,46.26,69L34.7,55.5a1.54,1.54,0,0,1-.36-1V39.35L12.05,17.06a1.48,1.48,0,0,1-.32-1.63,1.49,1.49,0,0,1,1.38-.93H70.89a1.49,1.49,0,0,1,1.38.93A1.48,1.48,0,0,1,72,17.06L48.89,40.11V68a1.51,1.51,0,0,1-1,1.41A1.6,1.6,0,0,1,47.39,69.5ZM37.34,54l8.55,10V39.49a1.52,1.52,0,0,1,.44-1.06L67.27,17.5H16.73L36.9,37.67a1.5,1.5,0,0,1,.44,1.06Z"
}));
const Filter = createSvg({
  name: 'filter',
  path: FilterGlyph
});

export default Filter;
export { FilterGlyph };
